var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "vuestic-breadcrumbs" }, [
    _c(
      "div",
      { staticClass: "vuestic-breadcrumbs__nav-section" },
      [
        _c(
          "router-link",
          {
            staticClass: "vuestic-breadcrumbs__nav-section-item",
            attrs: { to: { path: _vm.breadcrumbs.root.name } },
          },
          [
            _vm._v(
              "\n      " +
                _vm._s(_vm.$t(_vm.breadcrumbs.root.displayName)) +
                "\n    "
            ),
          ]
        ),
        _vm._l(_vm.displayedCrumbs, function (item, index) {
          return _c(
            "router-link",
            {
              key: index,
              staticClass: "vuestic-breadcrumbs__nav-section-item",
              class: { disabled: item.disabled },
              attrs: { to: { name: item.name } },
            },
            [_vm._v("\n      " + _vm._s(_vm.$t(item.displayName)) + "\n    ")]
          )
        }),
      ],
      2
    ),
    _c("div", { staticClass: "vuestic-breadcrumbs__help-section" }, [
      _c(
        "a",
        {
          staticClass: "btn btn-micro btn-info",
          attrs: { target: "_blank", href: _vm.currentRoute },
        },
        [_c("span", { staticClass: "vuestic-icon vuestic-icon-files" })]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }